<div class="bl-padding-left-md--0 bl-padding-right-md--0">
  <h2 class="bl-font-weight--900 bl-flex--auto bl-font-color--black bl-font-size--28 bl-margin-bottom--0">
    Terms & Conditions
  </h2>
  <div class="bl-font-size--14 bl-font-color--error" *ngIf="!allDisclosuresAccepted() && (pageSubmitted$ | async)">
    <i class="bl-margin-right--4 bl-font-size--24" [ngClass]="getDisclosureSelectedStatus()"></i> Required
  </div>

  <div class="bl-margin-y--16">Please review the following documents:</div>

  <div class="bl-padding-left--0 bl-padding-right--0">
    <div *ngFor="let disclosure of disclosures; let i = index" class="" id="smart-sign-disclosure-{{ i }}">
      <!-- Disclosure open poupup -->
      <div *ngIf="!disclosure.isLinkType" class="bl-margin-top--8">
        <div class="bl-margin-bottom--16">
          <button id="open-disclosure-panel" class="bl-text-align--left button-anchor"
            (click)="chkSelection(disclosure, i); openSlideInPanel(disclosure)">
            {{ disclosure.title }}
          </button>
        </div>
      </div>

      <div *ngIf="disclosure.isLinkType" class="bl-margin-bottom--16">
        <a [href]="disclosure.url" class="button-anchor" target="_blank" (click)="chkSelection(disclosure, i)">{{
          disclosure.urlDisplayText
          }}</a>
      </div>
    </div>
  </div>
  <div class="bl-margin-y--16" [innerHTML]="this.utilitiesService.normalizeSpaces(disclosure?.placeHolderAcceptText)">
  </div>
  @if(showVerificationHelpText) {<div class="bl-margin-y--16">{{"smartSignReview/identityVerifyHelpTxt"| dictionary }}
  </div>}

  <div class="bl-flex--auto">
    <ng-container *ngIf="isArray(disclosure.applicants)">
      @if(!isAllApplicantsVerified && !disableVerifyIdentityButton() && (pageSubmitted$ | async)) {
      <div class="bl-font-color--error bl-font-size--14 bl-margin-bottom--16" aria-label="error" aria-live="assertive">
        {{'smartSignReview/identityVerificationError'| dictionary}}</div>
      }
      @if(requiredValidation() && isOAOFlow && (pageSubmitted$ | async)) {
      <div class="bl-font-color--error bl-font-size--14 bl-margin-bottom--16" aria-label="error" aria-live="assertive">
        {{ 'smartSignReview/errorMessage' | dictionary }}
      </div>
      }
      <div *ngFor="let applicant of disclosure.applicants; let index = index">
        <div
          class=" bl-margin-bottom--16 bl-display--flex bl-flex-flow--wrap bl-align-items--center bl-justify-content--space-between">
          @if (isYouthMembership && index === 0){
          <label for="smart_sign_disclosure_acc_{{ index }}"
            class="bl-label bl-col-md-4 bl-col-12 bl-padding--0 bl-margin-bottom--8">
            <span class="bl-margin-left--32 bl-padding-left--8 bl-font-size--16 bl-font-weight--800" [innerHTML]="
                isApplicantExists(applicant.applicant)
                  ? getApplicantLabel(applicant.applicant)
                  : ('smartSignReview/acceptLabel' | dictionary)
              ">
            </span>
          </label>
          <div class="bl-col-md-8 bl-col-12 bl-display--flex bl-align-items--center bl-justify-content--space-between">

          <span *ngIf="isApplicantExists(applicant.applicant)"
            class="bl-font-size--14 bl-display--block bl-col-7 bl-col-md-6 bl-padding-md--0 bl-padding-left--32">
            {{applicantTypes[index].name}}
          </span>
          <span class="bl-font-size--14 bl-font-weight--400 bl-text-align--center bl-col-5">
            Youth Member
          </span>
          </div>
          } @else {
          <div class="bl-check-wrap bl-col-md-4 bl-col-12">
            <input type="checkbox" id="smart_sign_disclosure_acc_{{ index }}" #name="ngModel"
              [(ngModel)]="applicant.accepted"
              (change)="updateAcceptance(disclosure.applicants, '' + index, index, $event); keepCheckboxFocus('' + index)"
              [required]="getAllowToAccept(disclosure)" [disabled]="disableApplicantCheckbox(applicant)"
              (focus)="storeOriginalCheckboxValue('' + index, $event)" />
            <label for="smart_sign_disclosure_acc_{{ index }}"
              class="bl-label bl-margin-bottom--8">
              <span class="bl-required bl-font-size--16 bl-font-weight--800" [innerHTML]="
                    isApplicantExists(applicant.applicant)
                      ? getApplicantLabel(applicant.applicant)
                      : ('smartSignReview/acceptLabel' | dictionary)
                  ">
              </span>
            </label>
          </div>
          <div class="bl-col-md-8 bl-col-12 bl-display--flex bl-align-items--center bl-justify-content--space-between">
            <span *ngIf="isApplicantExists(applicant.applicant)"
              class="bl-font-size--14 bl-margin-left-md--0 bl-display--block bl-col-7 bl-col-md-6 bl-padding-md--0 bl-padding-right--0 bl-padding-left--32"
              [innerHTML]="applicantTypes[index].name">
            </span>
            @if (applicant.isVerified) {
            <span
              class="bl-font-color--success bl-font-size--12 bl-font-weight--700 bl-text-align--center bl-col-5">
              <i class="bl-padding-right--8 cu-check-circle-solid"></i>{{ 'smartSignReview/verified' | dictionary }}
            </span>
            } @else {
            <button class="bl-button bl-button-small bl-padding-x--0 bl-col-5"
              (click)="verifyIdentity(index)" [disabled]="disableVerifyIdentityButton()">
              {{ 'smartSignReview/identity' | dictionary }} <i class="bl-margin--0 cu-arrow-right"></i>
            </button>
            }
          </div>
          }
        </div>
      </div>
    </ng-container>
  </div>

  <ea-slide-in-panel class="full-panel" [(isSlidePanelVisible)]="isOpen" [slidePanelTitle]="docTitle"
    [fixedLayout]="true" openPanelElementId="open-smart-sign-disclosure-panel">
    <div *ngIf="isOpen"
      class="bl-border bl-border-radius bl-bg-color--white bl-padding-x--16 bl-padding-y--24 bl-padding-md--32">
      <ng-container *ngIf="isDataloaded">
        <div class="bl-display--flex bl-justify-content--flex-end bl-margin-bottom--16 bl-height--100">
          <h4
            class="bl-margin-bottom--0 bl-font-weight--900 bl-font-color--black bl-font-size--18 bl-margin-right--auto">
            {{ 'smartSignReview/review' | dictionary }}
          </h4>
          <button *ngIf="isDataloaded && pdfURL" (click)="printPDF()" id="smart-sign-printPDF-disclosure"
            class="bl-padding-right--24 bl-font-color--steel">
            <i class="cu-print bl-padding-right--8 bl-font-color--primary" alt="" aria-hidden="true"></i>
            <span>{{ 'smartSignReview/print' | dictionary }}</span>
          </button>

          <button *ngIf="isDataloaded && pdfURL" (click)="downloadPDF()" id="smart-sign-download-disclosure"
            class="bl-font-color--steel">
            <i class="cu-inbox-download bl-padding-right--8 bl-font-color--primary" alt="" aria-hidden="true"></i>
            <span>{{ 'smartSignReview/download' | dictionary }}</span>
          </button>
        </div>
        <div class="bl-padding--16 bl-position--relative" *ngIf="isDataloaded && pdfURL">
          <ecp-pdf-embed [pdfSrc]="pdfURL"></ecp-pdf-embed>
        </div>
        <div [innerHTML]="content" *ngIf="content"></div>
      </ng-container>
      <ng-container *ngIf="isOpen && !isDataloaded">
        <div class="bl-padding--16 bl-position--relative">
          <p class="bl-margin-y--24 bl-font-color--steel" [innerHTML]="'smartSignReview/loadingText' | dictionary"></p>
          <ecp-content-spinner [spinnerSmall]="true"></ecp-content-spinner>
        </div>
      </ng-container>
    </div>
  </ea-slide-in-panel>
</div>